import { ALL_VALUE } from "staticConfiguration";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useCentrixApi } from "./useCentrixApi";
import {
  type ProcessedBrandRegionData,
  useProcessBrandRegionData,
} from "./useProcessBrandRegionData";

export function useBrandRegionOptions(includeAll: boolean = false) {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:useBrandRegionOptions",
  });
  const processBrandRegionData = useProcessBrandRegionData();

  const { data, isError, isLoading } = useCentrixApi({
    path: "/api/shared-entities/organization-unit/brands",
  });

  const {
    brandOptions = [],
    regionOptions = [],
    brandRegionMap = {},
    brandCodes = [],
  } = useMemo(() => {
    if (!data) {
      return {
        brandOptions: [],
        regionOptions: [],
        brandRegionMap: {},
        brandCodes: [],
      } as ProcessedBrandRegionData;
    }
    const output = processBrandRegionData(data);
    if (includeAll) {
      output.brandOptions.unshift({ label: t("allBrands"), value: ALL_VALUE });
      output.regionOptions.unshift({
        label: t("allRegions"),
        value: ALL_VALUE,
      });
    }
    return output;
  }, [data, includeAll, processBrandRegionData, t]);

  return {
    brandOptions,
    regionOptions,
    brandRegionMap,
    brandCodes,
    data,
    isLoading,
    isError,
  };
}
